import type { ReactNode } from 'react';
import { oneliveAssets } from './assets';

interface Props {
  title: string;
  iconSrc?: string;
  children?: ReactNode;
}

/** 마이페이지 콘텐츠 영역 공통 섹션 헤더 */
export default function OneliveMypageSectionHead({ title, iconSrc, children }: Props) {
  const icon = iconSrc || oneliveAssets.drawerCoin;

  return (
    <div className="onelive-mypage-section">
      <div className="onelive-mypage-history-head">
        <span className="onelive-mypage-history-head-icon" aria-hidden="true">
          <img src={icon} alt="" />
        </span>
        <h2 className="onelive-mypage-history-head-title">{title}</h2>
      </div>
      {children ? <div className="onelive-mypage-section-body">{children}</div> : null}
    </div>
  );
}
